<template>
  <div class="welcome-intro">
    <!-- prettier-ignore -->
    <svg xmlns="http://www.w3.org/2000/svg" style="display:none"><symbol id="cloud-1" viewBox="0 0 679 263"><path d="M328.165 32.365C306.83 9.838 274.217-2.05 242.956.291c-39.058 2.913-75.076 25.91-98.541 57.281-23.492 31.373-35.29 70.393-38.642 109.465-25.13-8.585-54.468-3.486-75.205 13.11-13.617 10.874-23.232 26.482-27.442 43.339C.736 233.085-5.45 263 11.156 263h653.717c16.605 0 14.422-36.627 13.487-47.5-1.611-18.548-8.056-36.783-19.776-51.377-20.867-25.961-59.457-37.771-89.575-23.594.155-47.448-14.293-100.281-55.456-123.824C498.923 8.33 482.084 4.453 465.27 3.23c-45.554-3.277-92.876 13.866-123.41 47.865-3.716-6.867-8.341-13.137-13.669-18.756l-.026.026Z" fill="#F8F8F8"/></symbol><symbol id="cloud-2" viewBox="0 0 440 213"><path d="M42.962 212.45c6.04 1.237 329.34 0 380.005 0 50.664 0-19.31-130.55-109.78-70.766 0 0 31.651-147.043-47.033-141.533-88.284 6.185-65.157 103.638-65.157 103.638S38.143 57.499 7.974 127.028c-30.169 69.53 34.987 85.385 34.987 85.385v.037Z" fill="#F8F8F8"/></symbol><symbol id="cloud-3" viewBox="0 0 387 94"><path d="M375.657 92.972c-1.402.504-2.945.787-4.628.819-23.671.347-47.343.157-71.015.157-39.07 0-78.167 0-117.237-.063-37.892-.031-75.755-.094-113.647-.157-20.082 0-40.164-.095-60.246-.095-23.026 0 5.301-39.902 11.163-45.228 8.863-8.132 20.222-13.238 31.665-12.482 9.032.568 21.344 4.444 29.057 9.897 4.18 2.931 7.854 6.808 10.686 11.315 1.094 1.734 6.76 11.22 5.442 13.3 13.041-20.833 27.458-41.414 46.754-54.81 29.029-20.14 67.874-20.865 97.492-1.86 7.432 4.76 14.472 10.906 18.623 19.29 4.151 8.384 4.909 19.415.141 27.39 17.445-17.556 39.546-29.218 62.685-33.158 15.117-2.553 31.329-1.67 44.567 6.934 13.238 8.605 22.494 26.318 19.156 43.086-1.515 7.564-4.936 13.49-10.686 15.601l.028.064Z" fill="#F8F8F8"/></symbol><symbol id="cloud-4" viewBox="0 0 125 66"><path d="M25.912 46.908S11.833 29.647 23.357 12.24C34.87-5.165 76.078-9.774 79.157 37.837c0 0 2.555-11.549 11.267-9.998 8.702 1.551 6.404 12.05 6.404 12.05s27.13-12.63 28.156 6.104c1.027 18.734-48.671 18.477-64.267 18.477-15.595 0-59.359 6.416-60.642-7.03-1.283-13.444 14.079-15.542 25.848-10.521l-.011-.011Z" fill="#F8F8F8"/></symbol></svg>

    <h1 class="welcome-intro__title">{{ title }}</h1>

    <div class="welcome-intro__clouds">
      <svg class="welcome-intro__cloud"><use href="#cloud-4" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-1" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-3" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-3" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-1" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-2" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-3" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-2" /></svg>
      <svg class="welcome-intro__cloud"><use href="#cloud-1" /></svg>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<style lang="scss" scoped>
.welcome-intro {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: none;
  padding: var(--onboarding-padding);
  overflow: hidden;
  pointer-events: none;

  &__title {
    font-size: 32px;
    line-height: 36px;
    letter-spacing: -0.02em;
    text-align: center;
    text-wrap: balance;
    color: $c-black-2;
    font-weight: 500;
    animation: hide-title 0.5s 2.7s forwards;
  }

  &__clouds {
    position: absolute;
    inset: 0;
    display: grid;
    grid-template-areas: 'stack';
    justify-items: center;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
    max-width: 375px;
    max-height: 812px;
    margin: auto;
  }

  &__cloud {
    grid-area: stack;
    flex-shrink: 0;
    max-width: none;
    filter: drop-shadow(0 1px 41px rgba(0, 0, 0, 0.05));
    $moveDuration: var(--cloud-move-duration);
    $fadeDuration: var(--cloud-fade-duration);
    $fadeDelay: calc($moveDuration - $fadeDuration);
    animation:
      clouds-move $moveDuration cubic-bezier(0.2, 0.1, 0.2, 1) both,
      clouds-fade $fadeDuration $fadeDelay both;

    // Safari on mobile can't animate blurs properly, so we have
    // to use an different version of the `clouds-fade` keyframes.
    @media (max-width: $w-medium-s) {
      .sf-safari & {
        animation:
          clouds-move $moveDuration cubic-bezier(0.2, 0.1, 0.2, 1) both,
          clouds-fade-safari $fadeDuration $fadeDelay both;
      }
    }

    &:nth-child(1) {
      width: 125px;
      height: 66px;
      --cloud-Y: -170px;
      --cloud-initial-X: -120px;
      --cloud-final-X: -170px;
      --cloud-move-duration: 4s;
      --cloud-fade-duration: 1s;
    }

    &:nth-child(2) {
      width: 257px;
      height: 99px;
      --cloud-Y: -155px;
      --cloud-initial-X: 55px;
      --cloud-final-X: 155px;
      --cloud-move-duration: 3.5s;
      --cloud-fade-duration: 0.8s;
    }

    &:nth-child(3) {
      width: 188px;
      height: 40px;
      --cloud-Y: -85px;
      --cloud-initial-X: -110px;
      --cloud-final-X: -170px;
      --cloud-move-duration: 3.7s;
      --cloud-fade-duration: 1s;
    }

    &:nth-child(4) {
      width: 216px;
      height: 46px;
      --cloud-Y: -25px;
      --cloud-initial-X: 140px;
      --cloud-final-X: 180px;
      --cloud-move-duration: 2.5s;
      --cloud-fade-duration: 1s;
    }

    &:nth-child(5) {
      width: 441px;
      height: 171px;
      --cloud-Y: -5px;
      --cloud-initial-X: -100px;
      --cloud-final-X: -325px;
      --cloud-move-duration: 2.5s;
      --cloud-fade-duration: 2s;
      z-index: 1;
    }

    &:nth-child(6) {
      width: 318px;
      height: 152px;
      --cloud-Y: 30px;
      --cloud-initial-X: 75px;
      --cloud-final-X: 245px;
      --cloud-move-duration: 2.2s;
      --cloud-fade-duration: 1.8s;
    }

    &:nth-child(7) {
      width: 387px;
      height: 94px;
      --cloud-Y: 120px;
      --cloud-initial-X: -50px;
      --cloud-final-X: 170px;
      --cloud-move-duration: 2s;
      --cloud-fade-duration: 1.9s;
      z-index: 1;
    }

    &:nth-child(8) {
      width: 440px;
      height: 213px;
      --cloud-Y: 90px;
      --cloud-initial-X: 300px;
      --cloud-final-X: 360px;
      --cloud-move-duration: 2.6s;
      --cloud-fade-duration: 0.9s;
      z-index: 1;
    }

    &:nth-child(9) {
      width: 679px;
      height: 263px;
      --cloud-Y: 350px;
      --cloud-initial-X: 400px;
      --cloud-final-X: -100px;
      --cloud-move-duration: 4.3s;
      --cloud-fade-duration: 1.5s;
      z-index: 2;
    }
  }
}

@keyframes clouds-move {
  from {
    transform: translate(var(--cloud-initial-X), var(--cloud-Y));
  }
  to {
    transform: translate(var(--cloud-final-X), var(--cloud-Y));
  }
}

@keyframes clouds-fade {
  to {
    opacity: 0;
    filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0)) blur(20px);
  }
}

@keyframes clouds-fade-safari {
  to {
    opacity: 0;
  }
}

@keyframes hide-title {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
